module.exports = __webpack_public_path__ + "img/detailsimg.db52dd8f.png";